module.exports = __webpack_public_path__ + "static/media/avatar12.9af8ced4.jpg";